/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { createListenerMiddleware } from '@reduxjs/toolkit';
import mapValues from 'lodash/mapValues';

import { tableApi } from '../../../modules/table/store';


export const tableOrderListenerMiddleware = createListenerMiddleware();

/*
*  В запросе meta для таблицы заказов facets приходят в ordersInfo
*  Middleware ждет успешное получение меты и приводит значения к стандартному виду
*/
export const tableOrderListenerStart = () => {
    tableOrderListenerMiddleware.startListening({
        matcher: tableApi.endpoints.getTableMeta.matchFulfilled,
        effect: ({ payload }, listenerApi) => {
            const ordersInfo =
                // @ts-ignore
                mapValues(payload.ordersInfo, facets => facets.map(f => ({ label: f.name, value: f.id })));
            const facets = {
                action: ordersInfo.actions,
                status: ordersInfo.statuses,
            };
            listenerApi.dispatch(
                // @ts-ignore
                tableApi.util.updateQueryData('getTableMeta', { url: 'orders/meta' }, (draft) => {
                    draft.facets = facets
                }),
            )
        },
    });
}
